<script setup>
  import { computed } from 'vue';
  import { useUserStore } from '@/stores/UserStore';
  import { useMediaQuery } from '@/composables/useMediaQuery';
  import CompleteReportHeaderPrimaryActionList from '@/components/CompleteReportHeaderPrimaryActionList.vue';
  import CompleteReportHeaderSecondaryActionList from '@/components/CompleteReportHeaderSecondaryActionList.vue';
  import FavoriteSpotUserTip from "@/components/FavoriteSpotUserTip.vue";
  import Popup from '@/components/controls/Popup.vue';
  import useSettingsGlobals from '@/composables/useSettingsGlobals';

  const { $WEB_VIEW } = useSettingsGlobals();  

  const showProfileModal = defineModel('showProfileModal', { required: true });
  const showSettingsModal = defineModel('showSettingsModal', { required: true });

  const userStore = useUserStore();

  const isDesktop = useMediaQuery('(min-width: 840px)');
  const isSmallDevice = useMediaQuery('(max-width: 539px)');

  const showUserTip = computed(() => userStore.memberLevel > 0 && !isSmallDevice.value && !isDesktop.value && !$WEB_VIEW)
</script>

<template>
  <CompleteReportHeaderPrimaryActionList
    v-if="isDesktop"
    v-model:showProfileModal="showProfileModal"
  />
  <Popup
    v-else
    id="complete-report-jwx-action-menu"
    icon="more-menu"
    positionY="bottom"
    class="jwx-page-header__actions"
    :hideDivider="true"
  >
    <div class="jwx-action-menu">
      <CompleteReportHeaderPrimaryActionList
        v-model:showProfileModal="showProfileModal"
      />
      <CompleteReportHeaderSecondaryActionList
        v-if="userStore.nonTrialMemberLevel > -1"
        v-model:showSettingsModal="showSettingsModal"
      />
    </div>
    <template #misc>
      <FavoriteSpotUserTip
        v-if="showUserTip"
        :menu="true"
        alignment="right"
      />
    </template>
  </Popup>      
</template>